import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@/lib/utils';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef< typeof PopoverPrimitive.Content >,
  React.ComponentPropsWithoutRef< typeof PopoverPrimitive.Content >
>( ( { className, align = 'end', sideOffset = 4, ...props }, ref ) => {
  return (
    <PopoverPrimitive.Portal container={ window.agentwp }>
      <PopoverPrimitive.Content
        ref={ ref }
        align={ align }
        sideOffset={ sideOffset }
        className={ cn(
          'z-[10005] w-72 rounded-md text-sm bg-white p-3 text-slate-950 shadow-lg outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:bg-slate-950 dark:text-slate-50',
          className,
        ) }
        { ...props }
      />
    </PopoverPrimitive.Portal>
  );
} );
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
